const seo = {
  pages: {
    home: {
      title: "Elite Dental Solutions | Дентална клиника",
      description:
        "Съвременна дентална клиника с индивидуален подход, модерна апаратура и екип от специалисти. Запишете безплатна консултация и получете персонализиран план за лечение.",
    },
    prices: {
      title: "Ценоразпис | Elite Dental Solutions",
      description:
        "Разгледайте ориентировъчните цени на нашите дентални услуги. За точна оферта и план на лечение се свържете с нас за консултация.",
    },
    "request-quote": {
      title: "Безплатна консултация | Elite Dental Solutions",
      description:
        "Попълнете формата за запитване и запазете безплатна консултация. Ще се свържем с вас възможно най-скоро, за да уточним детайлите.",
    },
    "privacy-policy": {
      title: "Политика за поверителност | Elite Dental Solutions",
      description:
        "Научете как Elite Dental Solutions обработва и защитава личните ви данни, какви права имате и как да се свържете с нас относно поверителността.",
    },
    "terms-of-service": {
      title: "Общи условия | Elite Dental Solutions",
      description:
        "Прочетете общите условия за използване на услугите и уебсайта на Elite Dental Solutions, включително правила за часове, плащания и отговорности.",
    },
    "not-found": {
      title: "404 | Elite Dental Solutions",
      description: "Страницата не е намерена.",
    },
    services: {
      implantology: {
        title: "Имплантология | Elite Dental Solutions",
        description:
          "Зъбни импланти с прецизно планиране и висококачествени материали. Възстановете усмивката си с дълготрайно решение и професионална грижа.",
      },
      endodontics: {
        title: "Ендодонтия | Elite Dental Solutions",
        description:
          "Лечение на коренови канали с модерни методи и внимание към детайла. Облекчете болката и запазете естествения зъб.",
      },
      "oral-surgery": {
        title: "Орална хирургия | Elite Dental Solutions",
        description:
          "Орално-хирургични процедури с опитен екип и безопасен подход. Консултация, план и внимателно проследяване на възстановяването.",
      },
      periodontology: {
        title: "Пародонтология | Elite Dental Solutions",
        description:
          "Грижа за венците и лечение на пародонтални проблеми. Профилактика, диагностика и терапия за здрави венци и стабилна усмивка.",
      },
      orthodontics: {
        title: "Ортодонтия | Elite Dental Solutions",
        description:
          "Ортодонтско лечение за подредени зъби и правилна захапка. Индивидуален план и внимателно проследяване на резултатите.",
      },
      bonding: {
        title: "Бондинг | Elite Dental Solutions",
        description:
          "Естетичен бондинг за корекции на форма, цвят и дребни несъвършенства. Бързо и щадящо подобрение на усмивката.",
      },
      prosthetics: {
        title: "Протетика | Elite Dental Solutions",
        description:
          "Протетични решения – корони, мостове и протези – за комфорт и естествена визия. Персонализирана изработка и прецизно напасване.",
      },
      "lip-filler": {
        title: "Филър за устни | Elite Dental Solutions",
        description:
          "Естетични процедури с филър за устни с естествен резултат и внимание към пропорциите. Консултация и индивидуален подход.",
      },
      cariesology: {
        title: "Кариесология | Elite Dental Solutions",
        description:
          "Диагностика и лечение на кариеси с щадящи методи и качествени материали. Запазете здравината и естетиката на зъбите.",
      },
      "teeth-whitening": {
        title: "Избелване на зъби | Elite Dental Solutions",
        description:
          "Професионално избелване на зъби в клиника или с домашен комплект. Безопасен протокол и видими резултати.",
      },
      "dental-tourism": {
        title: "Дентален туризъм | Elite Dental Solutions",
        description:
          "Дентален туризъм в България с цялостна организация и висок стандарт на лечение. Получете план, оферта и съдействие за престоя.",
      },
    },
  },
};

export default seo;

